import React, { FC, useState, useEffect, useCallback } from "react";
import {
  Title,
  useNotify,
  useRefresh,
  useTranslate,
  Notification,
  useDataProvider,
  warning,
  useCreate,
  minLength,
} from "react-admin";
import {
  Button,
  createStyles,
  Divider,
  Grid,
  makeStyles,
  TextField,
  Theme,
  Tooltip,
  FormControlLabel,
  Checkbox,
  Box,
  MenuItem,
  FormHelperText,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { useForm, SubmitHandler, useController } from "react-hook-form";

type Inputs = {
  name: string;
  apiKey: string;
  encryptionKey: string;
  id: string;
};

const Create: FC = () => {
  const notify = useNotify();
  const dataProvider = useDataProvider();
  const refresh = useRefresh();
  const history = useHistory();

  const [name, setName] = useState<string>("");
  const [id, setId] = useState<string>("");
  const [encryptionKey, setEncryptionKey] = useState<string>("");
  const [apiKey, setApikey] = useState<string>("");

  const {
    register,
    handleSubmit,
    control,
    watch,
    setValue,
    formState: { errors, isDirty },
  } = useForm<Inputs>();
  const OnSubmit = () => {
    const created = {
      name: name,
      encryption_key: encryptionKey,
      id: id,
      apikey: apiKey,
    };

    dataProvider
      .create("company", {
        data: created,
      })
      .then((response: any) => {
        notify("Company was successfully created");
        history.push("/company");
      })
      .catch((error: any) => {
        notify(error.message, { type: "warning" });
      });
  };

  return (
    <Box sx={{ pl: 5, pt: 12 }}>
      <Title title="Invite User" />
      <Box>
        <form onSubmit={handleSubmit(OnSubmit)}>
          <Grid container spacing={1}>
            <Grid item md={2}>
              <TextField
                id="name"
                label="Name"
                placeholder="Enter Name"
                InputLabelProps={{ shrink: true, required: true }}
                onChange={(e: any) => {
                  setName(e.target.value);
                }}
                variant="outlined"
                fullWidth
                required
              />
            </Grid>
            <Grid item md={2}>
              <TextField
                id="id"
                label="Company Code"
                placeholder="Enter Company Code"
                InputLabelProps={{ shrink: true, required: true }}
                onChange={(e: any) => {
                  setId(e.target.value);
                }}
                variant="outlined"
                fullWidth
                type="text"
              />
            </Grid>
          </Grid>
          <Box sx={{ pb: 3 }}></Box>
          <Grid container spacing={2}>
            <Grid item xs={5} md={2}>
              <TextField
                id="apiKey"
                label="Api Key"
                placeholder="Enter Api Key"
                InputLabelProps={{ shrink: true, required: true }}
                onChange={(e: any) => {
                  setApikey(e.target.value);
                }}
                variant="outlined"
                fullWidth
                type="text"
              />
            </Grid>
            <Grid item xs={5} md={2}>
              <TextField
                id="encryptionKey"
                label="Encryption Key"
                placeholder="Enter Encryption Key"
                InputLabelProps={{ shrink: true, required: true }}
                onChange={(e: any) => {
                  setEncryptionKey(e.target.value);
                }}
                variant="outlined"
                fullWidth
                type="text"
              />
            </Grid>
          </Grid>
          <Box sx={{ p: 4 }}>
            <Divider />
          </Box>
          <Grid container spacing={2}>
            <Grid item md={3}>
              <Button
                type="button"
                onClick={handleSubmit(OnSubmit)}
                variant="contained"
                color="primary"
                size="large"
                disabled={
                  name == "" || encryptionKey == "" || apiKey == "" || id == ""
                    ? true
                    : false
                }
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </Box>
    </Box>
  );
};

export default Create;
